import { useRef } from 'react';
import { useBaseElement } from './useElement';
import TileLayer from 'ol/layer/Tile';

interface WMSTileLayerProps {
  tileLayer: TileLayer<any>;
}

export function WMSTileLayer({ tileLayer }: WMSTileLayerProps) {
  const elementRef = useRef(tileLayer);

  useBaseElement(elementRef.current, 'wmsBase');

  return null;
}
